import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronUp } from 'lucide-react';
import { trDisplay } from '../../i18n';
import { Button } from '../ui/button';

export default function SWRBackToTop({ pageRef, avoidRunAction = false }) {
  useTranslation();
  const [position, setPosition] = useState({ visible: false, bottom: null });

  useEffect(() => {
    const runAction = avoidRunAction ? pageRef.current?.querySelector('.swr-run-actions') : null;
    const update = () => {
      const bounds = runAction?.getBoundingClientRect();
      const bottom = window.innerWidth < 1024 && bounds?.width > 0
        ? Math.max(16, window.innerHeight - bounds.top + 12) : null;
      const visible = window.scrollY > 200;
      setPosition(previous => previous.visible === visible && previous.bottom === bottom
        ? previous : { visible, bottom });
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const observer = new ResizeObserver(update);
    if (runAction) observer.observe(runAction);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      observer.disconnect();
    };
  }, [avoidRunAction, pageRef]);

  if (!position.visible) return null;
  const label = trDisplay('Torna in cima');
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="swr-back-to-top h-11 w-11 bg-background text-foreground shadow-none active:border-foreground focus-visible:ring-2 focus-visible:ring-offset-2"
      style={position.bottom == null ? undefined : { bottom: position.bottom }}
      aria-label={label}
      title={label}
      data-testid="swr-back-to-top"
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        pageRef.current?.focus({ preventScroll: true });
      }}
    >
      <ChevronUp aria-hidden="true" />
    </Button>
  );
}
